var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 110.541,
    height: 87.511,
    viewBox: "0 0 110.541 87.511",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_159",
    "data-name": "Rectangle 159",
    width: 110.541,
    height: 87.511,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wallet",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_324",
    "data-name": "Mask Group 324",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M9.132,0H92.79a9.132,9.132,0,0,1,9.132,9.132V74.188a9.132,9.132,0,0,1-9.132,9.132H9.132A9.132,9.132,0,0,1,0,74.188V9.132A9.132,9.132,0,0,1,9.132,0Z",
    transform: "translate(1.821 2.096)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M171.234,83.153H140.592A4.605,4.605,0,0,1,136,78.562V62.591A4.605,4.605,0,0,1,140.592,58h30.642a4.605,4.605,0,0,1,4.591,4.591v15.97a4.605,4.605,0,0,1-4.591,4.591",
    transform: "translate(-65.009 -27.607)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M160.576,76.288a6.288,6.288,0,1,0-6.288,6.288,6.289,6.289,0,0,0,6.288-6.288",
    transform: "translate(-70.72 -33.319)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_49",
    "data-name": "Line 49",
    x2: 4.606,
    transform: "translate(9.212 9.212)",
    fill: "none",
    stroke: "#efefef",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_50",
    "data-name": "Line 50",
    x2: 66.813,
    transform: "translate(22.257 8.908)",
    fill: "none",
    stroke: "#efefef",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    strokeDasharray: "17 17"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_51",
    "data-name": "Line 51",
    x2: 4.606,
    transform: "translate(93.039 9.212)",
    fill: "none",
    stroke: "#efefef",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_52",
    "data-name": "Line 52",
    x2: 4.606,
    transform: "translate(9.212 76.457)",
    fill: "none",
    stroke: "#efefef",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_53",
    "data-name": "Line 53",
    x2: 66.813,
    transform: "translate(22.257 76.507)",
    fill: "none",
    stroke: "#efefef",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    strokeDasharray: "17 17"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_54",
    "data-name": "Line 54",
    x2: 4.606,
    transform: "translate(93.039 76.457)",
    fill: "none",
    stroke: "#efefef",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.6fe86046.svg";
export { ForwardRef as ReactComponent };